import React, { useState } from 'react'
import { connect } from 'react-redux'
import { actions as unitTestsActions } from '../../../../../../../store/reducers/unit-tests.reducer'
import TestModal from '../TestModal'
import { useAssignmentAccess } from '../../../../../components/access/Access'
import { Perm, State } from '../../../../../../../constants/assignment-permissions'

const EditStdinTestModal = ({ showEditStdinTestModal, setShowEditStdinTestModal, updateStdinUnitTest }) => {
    const [errorMessage, setErrorMessage] = useState('')
    const { hasAccess: hasEditingPermission } = useAssignmentAccess([Perm.CAN_EDIT, State.NOT_PROCESSING, State.NOT_MBA, State.UNPUBLISHED])

    const handleSubmitTest = (token, fields) => {
        setErrorMessage('')
        return updateStdinUnitTest(token, fields, setErrorMessage)
    }

    return (
        <TestModal
            showModal={showEditStdinTestModal}
            setShowModal={setShowEditStdinTestModal}
            submitTest={handleSubmitTest}
            modalTitle={hasEditingPermission ? 'Update stdin test' : 'View stdin test'}
            submitButtonText='Update'
            fields={{
                name: true,
                input: true,
                cpuTimeLimit: true,
                memoryLimit: true,
                exactMatch: true,
                ignoreCase: true,
                fixtureFiles: true,
            }}
            readOnly={!hasEditingPermission}
            errorMessage={errorMessage}
        />
    )
}

const mapState = ({ unitTests }) => {
    return {
        showEditStdinTestModal: unitTests.showEditStdinTestModal,
    }
}

const mapDispatch = dispatch => {
    return {
        setShowEditStdinTestModal: value => {
            dispatch(unitTestsActions.setShowEditStdinTestModal(value))
        },
        updateStdinUnitTest: (token, fields, setResponseMessage) => {
            return dispatch(unitTestsActions.updateStdinUnitTest(token, fields, setResponseMessage))
        },
    }
}

export default connect(mapState, mapDispatch)(EditStdinTestModal)
